import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppLayout from "./Common/Layout/AppLayout.jsx";
import PublicLayout from "./Common/Layout/PublicLayout.jsx";
import Login from "./Authentication/Login";
import VisaMasterList from "./Components/Visas/VisaMasterList.jsx";
import VisaMasterDetails from "./Components/Visas/VisaMasterDetails.jsx";
import CompanyClients from "./Components/Clients/CompanyClients.jsx";
import CompanySuppliers from "./Components/Suppliers/CompanySuppliers.jsx";
import CompanyAgents from "./Components/Agents/CompanyAgents.jsx";
import CreateTemplate from "./CompanyData/Admin/Template/CreateTemplate.jsx";
import ClientSubscriptions from "./Components/Subscriptions/ClientSubscriptions.jsx";
import ClientsVisaRequests from "./Components/Visas/ClientsVisaRequests.jsx";
import ClientWallet from "./Components/Clients/ClientWallet.jsx";
import AgentWallet from "./Components/Agents/AgentWallet.jsx";
import Account from "./Components/Accounts/Account.jsx";
import AccountType from "./Components/Accounts/AccountType.jsx";
import Item from "./Components/Accounts/Item.jsx";
import AccountItem from "./Components/Accounts/AccountItem.jsx";
import RequestDetails from "./Components/Visas/RequestDetails.jsx";
import SupplierVisaPrices from "./Components/Visas/SupplierVisaPrices.jsx";
import TaxRate from "./Components/Accounts/TaxRate.jsx";
import CompanyProfile from "./Components/Master/CompanyProfile.jsx";
import ChangePassword from "./Components/Master/ChangePassword.jsx";
import Users from "./Components/Master/Users.jsx";
import Branch from "./Components/Master/Branch.jsx";
import PaymentGateway from "./Components/Settings/PaymentGateway.jsx";
import FaqCategory from "./Components/Settings/FaqCategory.jsx";
import B2CCompanies from "./Components/Clients/B2CCompanies";
import B2BCompanies from "./Components/Clients/B2BCompanies";
import B2ECompanies from "./Components/Clients/B2ECompanies";
import BusBookings from "./Components/Bus/BusBookings";
import BusBookingDetails from "./Components/Bus/BookingDetails";
import HotelBookings from "./Components/Hotels/HotelBookings";
import SightSeeingBookings from "./Components/SightSeeing/SightSeeingBookings";
import SightSeeingBookingDetails from "./Components/SightSeeing/SightSeeingBookingDetails";
import FlightBookings from "./Components/Flight/FlightBookings";
import FlightBookingDetails from "./Components/Flight/FlightBookingDetails";
import AgentWebsiteShowcase from "./Website/AgentWebsiteShowcase.jsx";
import WebsiteTemplatePreviewPage from "./template-library/TemplatePreviewPage.jsx";
import CompanyDMCS from "./Components/DMCS/CompanyDMCS.jsx";
import HotelBookingDetails from "./Components/Hotels/HotelBookingDetails.jsx";
import WebsiteTemplates from "./Components/Templates/WebsiteTemplates.jsx";
import ManualInvoiceGenerator from "./Components/Settings/ManualInvoiceGenerator.jsx";
import FlightReports from "./Components/Reports/FlightReports.jsx";
import SupplierPayableReport from "./Components/Reports/SupplierPayableReport.jsx";
import FlightAmendmentRequest from "./Components/Flight/FlightAmendmentRequest.jsx";
import SubscriptionPlans from "./Components/Subscriptions/SubscriptionPlan.jsx";
import CompanyKYCDetails from "./Components/Clients/CompanyKYCDetails.jsx";
import PropertiesApproval from "./Components/Hotels/PropertiesApproval.jsx";
import AssignTemplateToAgent from "./Components/Clients/AssignTemplateToAgent.jsx";
import ManualSubscriptionInvoice from "./Components/Subscriptions/ManualSubscriptionInvoice.jsx";
import BusVoucher from "./Components/Bus/BusVoucher.jsx";
import BusCustomerInvoice from "./Components/Bus/BusCustomerInvoice.jsx";
import BusAgentInvoice from "./Components/Bus/BusAgentInvoice.jsx";
import BusDownload from "./Components/Bus/BusDownload.jsx";
import SubscriptionGstReport from "./Components/Subscriptions/SubscriptionGstReport.jsx";
import GlobalTax from "./Components/Accounts/GlobalTax.jsx";
import TaxCollection from "./Components/Accounts/TaxCollection.jsx";
import TaxRule from "./Components/Accounts/TaxRule.jsx";
import MasterPackageCreate from "./Components/Packages/MaterPackageCreate.jsx";
import PackagesList from "./Components/Packages/PackagesList.jsx";
import PackageDetails from "./Components/Packages/PackageDetails.jsx";
import PackagePreviewPage from "./Components/Packages/PackagePreviewPage.jsx";
import CompanyPackageEdit from "./Components/Packages/CompanyPackageEdit.jsx";
import FlightVoucher from "./Components/Flight/FlightVoucher.jsx";
import FlightInvoice from "./Components/Flight/FlightInvoice.jsx";
import CustomerFlightInvoice from "./Components/Flight/CustomerFlightInvoice.jsx";
import HotelVoucher from "./Components/Hotels/HotelVoucher.jsx";
import HotelInvoice from "./Components/Hotels/HotelInvoice.jsx";
import CustomerHotelInvoice from "./Components/Hotels/CustomerHotelInvoice.jsx";
import PackageEnquiryList from "./Components/Enquriy/PackageEnquiryList.jsx";
import ClientPaymentGateway from "./Components/Clients/ClientPaymentGateway.jsx";
import MasterCommissionsList from "./Components/Clients/MasterCommissionsList.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Login />} />
        </Route>

        <Route element={<AppLayout />}>
          <Route path="/company/clients" element={<CompanyClients />} />
          <Route path="/b2c-companies" element={<B2CCompanies />} />
          <Route path="/b2b-companies" element={<B2BCompanies />} />
          <Route path="/b2e-companies" element={<B2ECompanies />} />
          <Route path="/buses" element={<BusBookings />} />
          <Route path="/bus/booking/:bookingId" element={<BusBookingDetails />} />
          <Route path="/hotels" element={<HotelBookings />} />
          <Route path="/hotel/booking/:hotelBookingId" element={<HotelBookingDetails />} />
          <Route path="/sightseeing" element={<SightSeeingBookings />} />
          <Route path="/sightseeing/booking/:sightSeeingBookingId" element={<SightSeeingBookingDetails />} />
          <Route path="/flights" element={<FlightBookings />} />
          <Route path="/flight/booking/:flightBookingId" element={<FlightBookingDetails />} />
          <Route path="/company/suppliers" element={<CompanySuppliers />} />
          <Route path="/company/agents" element={<CompanyAgents />} />
          <Route path="/clientwallet" element={<ClientWallet />} />
          <Route path="/agentwallet" element={<AgentWallet />} />
          <Route path="/client/visarequests" element={<ClientsVisaRequests />} />
          <Route path="/accounttypes" element={<AccountType />} />
          <Route path="/accounts" element={<Account />} />
          <Route path="/items" element={<Item />} />
          <Route path="/accountitems" element={<AccountItem />} />
          <Route path="/create-template" element={<CreateTemplate />} />
          <Route path="/visamasterlist" element={<VisaMasterList />} />
          <Route path="/visa-master/details/:id" element={<VisaMasterDetails />} />
          <Route path="/request/:visaRequestId" element={<RequestDetails />} />
          <Route path="/supplier/visaprices" element={<SupplierVisaPrices />} />
          <Route path="/taxrates" element={<TaxRate />} />
          <Route path="/client/subscriptionlist" element={<ClientSubscriptions />} />
          <Route path="/companyprofile" element={<CompanyProfile />} />
          <Route path="/branchs" element={<Branch />} />
          <Route path="/users" element={<Users />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/paymentgateways" element={<PaymentGateway />} />
          <Route path="/faqcategory" element={<FaqCategory />} />
          <Route path="/company/dmcs" element={<CompanyDMCS />} />
          <Route path="/agent-website-showcase" element={<AgentWebsiteShowcase />} />
          <Route path="/create/template" element={<WebsiteTemplates />} />
          <Route path="/manual-invoice-generator" element={<ManualInvoiceGenerator />} />
          <Route path="/flight-reports" element={<FlightReports />} />
          <Route path="/supplier-payable-report" element={<SupplierPayableReport />} />
          <Route path="/flight/amendmentrequest" element={<FlightAmendmentRequest />} />
          <Route path="/subscriptionplans" element={<SubscriptionPlans />} />
          <Route path="/admin/company-kyc/:companyId" element={<CompanyKYCDetails />} />
          <Route path="/properties/approvals" element={<PropertiesApproval />} />
          <Route path="/assign-template-to-agent" element={<AssignTemplateToAgent />} />
          <Route path="/manual/subscription-invoice" element={<ManualSubscriptionInvoice />} />
          <Route path="/bus/voucher/:bookingId" element={<BusVoucher />} />
          <Route path="/bus/customer-invoice/:bookingId" element={<BusCustomerInvoice />} />
          <Route path="/bus/agent-invoice/:bookingId" element={<BusAgentInvoice />} />
          <Route path="/bus/download/:bookingId" element={<BusDownload />} />
          <Route path="/subscription-gst/report" element={<SubscriptionGstReport />} />
          <Route path="/global-taxes" element={<GlobalTax />} />
          <Route path="/taxcollection" element={<TaxCollection />} />
          <Route path="/taxrules" element={<TaxRule />} />
          <Route path="/createpackage" element={<MasterPackageCreate />} />
          <Route path="/packageslist" element={<PackagesList />} />
          <Route path="/packages/view/:id" element={<PackageDetails />} />
          <Route path="/package-preview" element={<PackagePreviewPage />} />
          <Route path="/packages/edit/:id" element={<CompanyPackageEdit />} />
          <Route path="/flight/voucher/:flightBookingId" element={<FlightVoucher />} />
          <Route path="/flight/invoice/:flightBookingId" element={<FlightInvoice />} />
          <Route path="/flight/customer-invoice/:flightBookingId" element={<CustomerFlightInvoice />} />
          <Route path="/hotel/voucher/:hotelBookingId" element={<HotelVoucher />} />
          <Route path="/hotel/invoice/:hotelBookingId" element={<HotelInvoice />} />
          <Route path="/hotel/customer-invoice/:hotelBookingId" element={<CustomerHotelInvoice />} />
          <Route path="/client/paymentgatewaylist" element={<ClientPaymentGateway />} />
           <Route path="/master/commissionlist" element={<MasterCommissionsList />} />
          
            <Route path="/package/enquirylist" element={<PackageEnquiryList />} />


        </Route>
        <Route path="/template-preview/:templateId" element={<WebsiteTemplatePreviewPage />} />
        <Route path="/template-preview/:templateId/:viewName" element={<WebsiteTemplatePreviewPage />} />
        <Route path="/template-preview/:templateId" element={<WebsiteTemplatePreviewPage />} />
        {/* 2. This route handles the Package Details inside the Preview */}
        <Route path="/template-preview/:templateId/package/:packageId" element={<WebsiteTemplatePreviewPage />} />
        <Route path="/template-preview/:packageId/:templateId" element={<WebsiteTemplatePreviewPage />} />






      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />

    </>
  );
}

export default App;
